import React from 'react';
import useImageViewer from './useImageViewer';
import ImageViewer from './index';
const ImageViewerHelperView = ({}) => {
    const [imageViewerState, imageViewerActions] = useImageViewer();
    return (React.createElement(ImageViewer, { ...imageViewerState, onClose: imageViewerActions.hide }));
};
export default ImageViewerHelperView;
